import React, { useContext } from "react";
import { ProtectedLayout } from "./ProtectedLayout";
import { Navigate } from "react-router-dom";
import AuthContext from "../../context/AuthContext";

interface Props {
  children: JSX.Element | JSX.Element[];
}
export const ProtectedRoute = ({ children }: Props) => {
  const { validateToken } = useContext(AuthContext);
  if (!validateToken()) {
    return <Navigate to="/" replace />;
  }

  return <ProtectedLayout>{children}</ProtectedLayout>;
};
